import React, { useEffect, useState } from 'react';

import { API } from 'constants';
import client from 'services/cycle-api';

import { STAGE_TYPE } from '../../../../constants/cycleDetail';

import Modal from '../../../../design-system/Modal/Modal';
import Loading from '../../../../components/Loading';
import ModalHeader from '../../../../design-system/ModalHeader/ModalHeader';
import QuestionnaireViewOnlyContent from '../QuestionnaireViewOnlyContent/QuestionnaireViewOnlyContent';

const ReviewQuestionnaireModal = ({ type, details, onClose }) => {
    const [questionnaire, setQuestionnaire] = useState(() => {
        if (type === STAGE_TYPE.clear_picture) {
            return (details.questionnaire || []).slice().sort((a, b) => a.order - b.order);
        }
        return null;
    });

    useEffect(() => {
        if (type !== STAGE_TYPE.realistic_design || questionnaire) return;

        const fetchQuestionnaire = async (id) => {
            try {
                const { data } = await client.get(API.ROUTES.cycle.cycleStage + id + '/');
                const questionnaireData = data?.default_version?.details?.questionnaire || [];
                setQuestionnaire(questionnaireData);
            } catch (e) {
                onClose();
            }
        };

        const id = details.questionnaire?.stage_id;

        if (id) {
            void fetchQuestionnaire(id);
        } else {
            setQuestionnaire([]);
        }
    }, []);

    return (
        <Modal size="mediumPlus" resetPadding onClose={onClose}>
            <div className="flex flex-col max-h-[90vh] sm:max-h-[70vh]">
                <ModalHeader
                    title="Review Questionnaire"
                    outlined
                    customPaddings="px-5 py-3"
                    onClose={onClose}
                />

                <div className="p-5 overflow-y-auto">
                    {questionnaire && (
                        <QuestionnaireViewOnlyContent questionnaire={questionnaire} />
                    )}

                    {!questionnaire && (
                        <div>
                            <Loading withText={false} />
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ReviewQuestionnaireModal;
